module.exports = __webpack_public_path__ + "img/Hypoxia-BRCA_her2st.60b549c1.png";